/**
 * 금털기(CarryGold) 공통 설정 파일
 *
 * 대시보드 오퍼월(매출) 메타를 한 곳에서 관리한다.
 * 오퍼월을 추가/삭제하거나 그룹/이름을 바꿀 때는 이 파일만 수정하면 된다.
 *
 * - column: DAILY_SALES_STATISTICS 테이블 컬럼명 (매출 추이 차트에서 사용)
 * - field:  대시보드 오늘매출(dashboard_info) 속성명 (소문자)
 * - label:  화면 표시 이름
 * - bundle: 오늘매출 화면의 그룹 번호 (번들끼리 한 칸 띄우고, 번들 내에서는 매출순 정렬)
 */
export const OFFERWALL_PLATFORMS = [
    { column: 'TNK',      field: 'tnk',            label: 'TNK',      bundle: 1 },
    { column: 'SNAPPLAY', field: 'snapplay',       label: 'SNAPPLAY', bundle: 1 },
    { column: 'PINCRUX',  field: 'pincrux_ticket', label: '핀크럭스', bundle: 1 },
    { column: 'GMO',      field: 'gmo',            label: 'GMO',      bundle: 2 },
    { column: 'NAS',      field: 'nstation',       label: 'NSTATION', bundle: 1 },
    { column: 'CPX',      field: 'cpx',            label: 'CPX',      bundle: 2 },
    { column: 'MAF',      field: 'maf',            label: 'MAF',      bundle: 2 },
    { column: 'DT',       field: 'dt',             label: 'DT',       bundle: 2 },
    { column: 'POPCON',   field: 'popcon',         label: 'POPCON',   bundle: 2 },
    { column: 'MALLPIE',  field: 'mallpie',        label: '몰파이',   bundle: 3 },
    { column: 'TYRADS',   field: 'tyrads',         label: 'TyrAds',   bundle: 2 },
    { column: 'ADJO',     field: 'adjo',           label: 'ADJO',     bundle: 2 },
];

/**
 * 오퍼월 키 목록 — 전면이벤트(Game_EventNoti) 링크타입=오퍼월일 때 드롭다운에서 선택.
 * 금털기(CarryGold)에서 실제 사용하는 키값(대소문자 그대로). cpu 와 목록이 다르다.
 * 오퍼월을 추가/삭제할 때는 이 배열만 수정하면 된다.
 */
export const OFFERWALL_KEYS = [
    'SNAPPLAY',
    'MAF',
    'TNK',
    'NAS',
    'CPX',
    'PINCRUX',
    'GMO',
    'DT',
    'ADJO',
    'TYR',
    'MALLPIE',
    'NSTATION',
    'TYRADS',
    'TNKShopping',
    'SnapplayShopping',
];

// 매출 추이 차트 플랫폼 탭 — { key(=DB 컬럼), label }
export const SALES_PLATFORM_KEYS = OFFERWALL_PLATFORMS.map((p) => ({ key: p.column, label: p.label }));

// 오늘매출 번들 — [[{ label, field }, ...], ...] (bundle 번호 오름차순으로 그룹화)
export const OFFERWALL_BUNDLES = (() => {
    const bundleNos = [...new Set(OFFERWALL_PLATFORMS.map((p) => p.bundle))].sort((a, b) => a - b);
    return bundleNos.map((no) =>
        OFFERWALL_PLATFORMS
            .filter((p) => p.bundle === no)
            .map((p) => ({ label: p.label, field: p.field }))
    );
})();

export default {
    OFFERWALL_PLATFORMS,
    OFFERWALL_KEYS,
    SALES_PLATFORM_KEYS,
    OFFERWALL_BUNDLES,
};
